import { useState, useEffect } from 'react';
import { useAuth } from './useAuth';
import { useSupabase } from '../contexts/SupabaseContext';

const ADMIN_EMAIL = 'rica@presida.club';

export const useIsAdmin = () => {
  const { user } = useAuth();
  const { supabase } = useSupabase();
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAdminRole = async () => {
      if (!user) {
        setIsAdmin(false);
        setLoading(false);
        return;
      }

      if (user.email === ADMIN_EMAIL) {
        setIsAdmin(true);
        setLoading(false);
        return;
      }

      try {
        const { data, error } = await supabase
          .from('profiles')
          .select('role, email')
          .eq('id', user.id)
          .maybeSingle();

        if (error) {
          console.error('Error checking admin role:', error);
          setIsAdmin(false);
          return;
        }

        setIsAdmin(data?.role === 'admin' || data?.email === ADMIN_EMAIL);
      } catch (error) {
        console.error('Error checking admin role:', error);
        setIsAdmin(false);
      } finally {
        setLoading(false);
      }
    };

    checkAdminRole();
  }, [user, supabase]);

  return { isAdmin, loading };
};
